module.exports = __webpack_public_path__ + "static/media/kfc-24-67.0980a36e.jpg";